interface ITestimonial {
  author: string;
  designation: string;
  text: string;
}
export const Testimonial: React.FC<ITestimonial> = ({
  author,
  designation,
  text,
}) => {
  return (
    <div className={'p-6 mx-3 rounded-md border-sm border-grey-300 sm:mx-0'}>
      <p className="font-bold text-s-24 text-font-500 sm:text-s-20">{author}</p>
      <p className="text-base sm:text-s-12">{designation}</p>
      <p className="pt-10 h-64 sm:h-56 sm:text-s-14 sm:pt-7">{text}</p>
    </div>
  );
};
